<div class="row justify-content-center">
    <div *ngIf="isLoading">
        <div class="loader loader7"></div>
    </div>
    <div *ngIf="isLoading">
        <div *ngIf="!!isStructureComponent">
            <br>
            <span>
                {{'habilitation.structure.' + habilitationType + '.loaderMessage' | translate}}
            </span>
        </div>
    </div>
</div>
